import type { SerializedError } from '@reduxjs/toolkit';
import type { RejectApiResponse } from '@/shared/types/common';

export const getErrorMessage = (
  error: RejectApiResponse | SerializedError | undefined,
): string | null => {
  if (!error) return null;

  if ('success' in error && !error.success) return error.message;

  if ('message' in error && error.message) return error.message;

  return 'Unknown error';
};
